module.exports = __webpack_public_path__ + "static/media/21ECLAC40.8a5bac6f.jpg";